// js
import { connect } from 'react-redux';
import { downloadXLSTemplates } from '../actions/xlsImportActions';
import TemplateDownloaderPage from '../components/TemplateDownloaderPage';


const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
    onDownloadTemplates: settings => (
      dispatch(downloadXLSTemplates({ ...settings, dsaType: ownProps.dsaType }))
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateDownloaderPage);



// WEBPACK FOOTER //
// ./src/containers/TemplateDownloaderPage.js